import {
  ApiCallState,
  callInitiated,
  callSucceeded,
  callFailed
} from '../../../types'
import { addOrUpdateSystemParam } from './helpers'
import { SystemParamAction } from './actions'
import { SystemParam } from './types'

export interface State {
  systemParams?: SystemParam[]
  pending: boolean
  error: boolean
  apiCall: ApiCallState
}

export const initialState: State = {
  systemParams: undefined,
  pending: true,
  error: false,
  apiCall: { pending: false, error: false }
}

export default (state = initialState, action: SystemParamAction): State => {
  switch (action.type) {
    case 'sysparam.fetch':
      return {
        ...state,
        pending: true,
        systemParams: undefined,
        error: false
      }
    case 'sysparam.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'sysparam.saveSystemParam':
    case 'sysparam.deleteSystemParams':
      return { ...state, apiCall: { ...callInitiated } }

    case 'sysparam.changeConfirmed':
      return { ...state, apiCall: { ...callSucceeded } }

    case 'sysparam.changeTimedOut':
    case 'sysparam.saveSystemParamFailure':
    case 'sysparam.deleteSystemParamsFailure':
      return { ...state, apiCall: { ...callFailed } }

    case 'sysparam.addSystemParams':
      let items: SystemParam[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      return {
        ...state,
        systemParams: addOrUpdateSystemParam(state.systemParams ?? [], items)
      }
    default:
      return state
  }
}
